import { useContext } from "react";
import { DialogHeader } from "@hireart/component-library";
import clsx from "clsx";
import PropTypes from "prop-types";
import { ModalLabelContext } from "./ModalLabelContext";
import "./modal-header.scss";

export const ModalHeader = ({
  children,
  className = "",
  closeIcon,
  onClose,
  ...props
}) => {
  const labelId = useContext(ModalLabelContext);

  return (
    <DialogHeader
      {...props}
      id={labelId}
      className={clsx("ha-modal-header", className)}
    >
      {children}
    </DialogHeader>
  );
};

/* eslint-disable react/boolean-prop-naming */
ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  closeIcon: PropTypes.bool,
  onClose: PropTypes.func,
};
/* eslint-enable react/boolean-prop-naming */
